/* eslint-disable camelcase */
import React, { Component, Fragment } from 'react'
import _get from 'lodash/get'
import _isEmpty from 'lodash/isEmpty'
import _isEqual from 'lodash/isEqual'
import _includes from 'lodash/includes'
// functions
import { createMap } from './createMap'
// constants
import { COLORS, SEAT_STATUSES, SEAT_TYPES } from './constants'
// css
import './seatMapView.css'
import './seatMapViewPPP.css'
// components
import { ColorLabels, ColorLabelsPPP } from './ColorLabels'
import { ControlButtons } from './ControlButtons'
import { MouseLabel } from './MouseLabel'
import { tierColorObj } from './drawMap/drawGroupSeats'

const nullFn = () => null

class SeatMapView extends Component {
  constructor(props) {
    super(props)
    this.state = {
      statuses: props.statuses,
      events: this.createEvents(),
      seatLabelParams: {
        price: null,
        row: null,
        seat: null,
        status: null,
        section: null,
        color: null,
        top: null,
        left: null,
        visible: false,
        showReserveButton: false,
        onReservationButtonClick: null,
        tierId: null,
        seatType: SEAT_TYPES.CHAIR,
        seatLabelPriceText: 'Price'
      },
      showStatusesLabel: {
        [SEAT_STATUSES.HOLD]: false,
        [SEAT_STATUSES.BLOCKED]: false,
        [SEAT_STATUSES.AVAILABLE]: true,
        [SEAT_STATUSES.RESERVED]: !props.isBlockMap,
        [SEAT_STATUSES.BOOKED]: true,
        [SEAT_STATUSES.PREDEFINED]: !_isEmpty(props.predefinedSeats),
        [SEAT_TYPES.WHEELCHAIR]: false
      },
      selectionInProgress: false,
      isBlockMap: props.isBlockMap || false,
      ticketTypeTireRelationsArray: props.ticketTypeTireRelationsArray,
      tierPrices: props.tierPrices
    }

    this.controlsReset = nullFn
    this.is_PPP = false
    this.lastTappedSeat = null
  }

  async componentDidMount() {
    const { exportTiersColors = () => {} } = this.props
    await this.drawMapComponent()
    this.startAnimation && this.startAnimation()
    exportTiersColors(tierColorObj)
  }

  componentDidUpdate(prevProps) {
    const { statuses, loading, activeGroups, selectedTierId } = this.props

    if (!_isEqual(prevProps.statuses, statuses)) {
      this.processNewStatuses(statuses)
    }

    if (prevProps.loading !== loading) {
      document.body.style.cursor = loading ? 'progress' : 'auto'
    }

    if (
      prevProps.activeGroups !== this.props.activeGroups &&
      this.activateGroups
    ) {
      this.activateGroups(activeGroups)
    }

    const { seatsToRecolor: nextSeatsToRecolor = [] } = this.props
    const { seatsToRecolor = [] } = prevProps
    if (nextSeatsToRecolor !== seatsToRecolor && this.recolorSeats) {
      const seatIdsToRecolor = nextSeatsToRecolor.map(({ seatId }) => seatId)
      const seatsToRecover = seatsToRecolor.filter(({ seatId }) => {
        return !seatIdsToRecolor.includes(seatId)
      })
      if (this.recolorSeats) {
        this.recolorSeats(nextSeatsToRecolor, seatsToRecover)
      }
    }
    if (selectedTierId && prevProps.selectedTierId !== selectedTierId) {
      this.cancelAnimation()
      this.drawMapComponent()
    }
    if (!_isEqual(prevProps.seatData, this.props.seatData)) {
      this.cancelAnimation()
      this.drawMapComponent()
    }
    this.startAnimation && this.startAnimation()
  }

  componentWillUnmount() {
    if (this.cancelAnimation) {
      this.cancelAnimation()
    }
  }

  createEvents() {
    const {
      props,
      preEventHandler,
      seatClick,
      mouseOutSeat,
      mouseOverSeat,
      onSelectUp,
      clearTap,
      seatTap,
      onSelectStart
    } = this
    return {
      onClick: preEventHandler(seatClick),
      onTap: preEventHandler(seatTap),
      onMouseOver: preEventHandler(mouseOverSeat),
      onMouseOut: preEventHandler(mouseOutSeat),
      onTierIdChange: preEventHandler(props.events.onTierIdChange),
      onSelectUp: preEventHandler(onSelectUp),
      onClearTap: preEventHandler(clearTap),
      onSelectStart: preEventHandler(onSelectStart)
    }
  }

  preEventHandler =
    (eventFn) =>
    (...args) => {
      if (this.props.disabled) {
        return null
      }
      return eventFn(...args)
    }

  drawMapComponent = async () => {
    const { events, statuses, isBlockMap = false } = this.state
    const {
      width,
      height,
      predefinedSeats,
      isSelectionOn,
      activeGroups,
      seatsToRecolor = [],
      enableTicketTypeAssign = false,
      disabled,
      selectedTierId,
      seatData: {
        meta: {
          center_x,
          center_y,
          range_x,
          range_y,
          minZoomDistance,
          seat_circle_radius,
          name
        },
        seatmap,
        groups,
        creatorInfo,
        svgData
      }
    } = this.props
    const backgroundColor = _get(svgData, 'bgColor', COLORS.BACKGROUND)
    const container = document.getElementById('seatCanvasContainer')
    const {
      recolorSeats,
      cancelAnimation,
      statusesUpdate,
      controlsReset,
      controlsZoomIn,
      controlsZoomOut,
      activateGroups,
      startAnimation
    } = await createMap(
      container,
      seatmap,
      groups,
      creatorInfo,
      predefinedSeats,
      {
        width,
        height,
        center_x,
        center_y,
        range_x,
        range_y,
        minZoomDistance,
        backgroundColor,
        seat_circle_radius,
        statuses,
        events,
        isSelectionOn,
        isBlockMap,
        svgData,
        enableTicketTypeAssign,
        disabled,
        selectedTierId
      }
    )

    // eslint-disable-next-line no-undef
    window.document.dispatchEvent(new CustomEvent('mapDrawn'))
    this.controlsReset = controlsReset
    this.controlsZoomIn = controlsZoomIn
    this.controlsZoomOut = controlsZoomOut
    this.cancelAnimation = cancelAnimation
    this.startAnimation = startAnimation
    this.statusesUpdate = statusesUpdate
    this.activateGroups = activateGroups
    this.recolorSeats = recolorSeats
    if (name === 'papaya') {
      this.is_PPP = true
    }

    this.activateGroups(activeGroups)
    this.recolorSeats(seatsToRecolor)
    this.processNewStatuses(statuses)

    this.setState({
      showStatusesLabel: {
        ...this.state.showStatusesLabel,
        [SEAT_TYPES.WHEELCHAIR]: this.areThereWheelchairSeats()
      }
    })
  }

  areThereWheelchairSeats() {
    const { seatmap } = this.props.seatData
    return !!seatmap.find((group) => {
      return (
        group.children &&
        !!group.children.find((row) => {
          return (
            row.children &&
            !!row.children.find((seat) => seat.type === SEAT_TYPES.WHEELCHAIR)
          )
        })
      )
    })
  }

  processNewStatuses(statuses) {
    const { enableTicketTypeAssign } = this.props
    if (!enableTicketTypeAssign && this.statusesUpdate) {
      const statusesCount = this.statusesUpdate(statuses)

      this.setState({
        statuses,
        showStatusesLabel: {
          ...this.state.showStatusesLabel,
          [SEAT_STATUSES.HOLD]:
            statusesCount && statusesCount.get(SEAT_STATUSES.HOLD) > 0,
          [SEAT_STATUSES.BLOCKED]:
            statusesCount && statusesCount.get(SEAT_STATUSES.BLOCKED) > 0
        }
      })
    }
  }

  mouseOverSeat = (e, isTab = false) => {
    if (e.seat?.objectType === 'UNCLICKABLE_TABLE') {
      return
    }
    if (this.selectionInProgress || this.props.disableHoverPopup) {
      return
    }

    const { seat, position } = e
    if (!seat) return
    if (this.state.isBlockMap) {
      seat.status === SEAT_STATUSES.AVAILABLE &&
        seat.changeBorderColor(COLORS.SELECTED_BLOCK_BORDER)

      if (seat.status === SEAT_STATUSES.AVAILABLE) {
        document.body.style.cursor = this.props.loading ? 'progress' : 'pointer'
      }
    } else {
      const { enableTicketTypeAssign } = this.props
      seat.changeBorderColor('#000000')
      const seatLabelParams = { ...this.state.seatLabelParams }
      seatLabelParams.showReserveButton = false
      seatLabelParams.onReservationButtonClick = () => {}
      if (!seat.isExternalLink) {
        // eslint-disable-next-line prefer-const
        switch (seat.status) {
          case SEAT_STATUSES.AVAILABLE:
            seatLabelParams.status = 'Available'
            seatLabelParams.isReservedByMe = false
            seatLabelParams.showReserveButton = isTab
            seatLabelParams.onReservationButtonClick = () => {
              this.seatClick(e)
              this.clearTap()
            }
            document.body.style.cursor = this.props.loading
              ? 'progress'
              : 'pointer'
            break
          case SEAT_STATUSES.HOLD:
            seatLabelParams.status = 'On Hold'
            seatLabelParams.isReservedByMe = false
            document.body.style.cursor = this.props.loading
              ? 'progress'
              : 'pointer'
            break
          case SEAT_STATUSES.RESERVED:
            seatLabelParams.status = 'Reserved'
            seatLabelParams.isReservedByMe = false
            break
          case SEAT_STATUSES.RESERVED_BY_ME:
            seatLabelParams.status = 'Reserved'
            seatLabelParams.isReservedByMe = true
            document.body.style.cursor = this.props.loading
              ? 'progress'
              : 'pointer'
            break
          case SEAT_STATUSES.BOOKED:
            seatLabelParams.status = 'Sold'
            seatLabelParams.isReservedByMe = false
            break
          case SEAT_STATUSES.BLOCKED:
            seatLabelParams.status = 'BLOCKED'
            seatLabelParams.isReservedByMe = false
            break
          default:
            seatLabelParams.status = 'Sold'
            seatLabelParams.isReservedByMe = false
            break
        }
        seatLabelParams.visible = true
      } else {
        seatLabelParams.visible = false
        document.body.style.cursor = 'pointer'
      }

      if (enableTicketTypeAssign) {
        document.body.style.cursor = 'pointer'
      }

      seatLabelParams.color = `#${seat.material.color.getHexString()}`
      seatLabelParams.sgType = seat.sgType
      seatLabelParams.top = position.y
      seatLabelParams.left = position.x
      seatLabelParams.seat = seat.label
      seatLabelParams.row = seat.rowLabel
      seatLabelParams.seatType = seat.seatType
      seatLabelParams.section = seat.sectionLabel
      seatLabelParams.tierId = seat.tierId
      seatLabelParams.price = _get(window, `tierPrices.${seat.tierId}`, '')
      seatLabelParams.tierNames = _get(window, `tierNames.${seat.tierId}`, '')
      seatLabelParams.seatLabelPriceText = _get(
        window,
        'seatLabelPriceText',
        'Price'
      )
      seatLabelParams.buyerInfo = _get(
        this.props,
        `buyersInfo.${seat.seatId}`,
        null
      )
      this.setSeatLabelParameter(seatLabelParams)
    }
  }

  mouseOutSeat = (e) => {
    const { seat } = e
    if (seat.objectType === 'UNCLICKABLE_TABLE') {
      return
    }
    !seat.isSelected && seat.changeBorderColorToDefault()
    document.body.style.cursor = this.props.loading ? 'progress' : 'auto'
    this.setSeatLabelParameter({ visible: false })
  }

  seatClick = (e) => {
    if (!e.seat || (e.seat && e.seat.disabled)) {
      return
    }

    if (e.seat.objectType === 'UNCLICKABLE_TABLE') {
      return
    }

    this.setSeatLabelParameter({ visible: false })
    this.props.events.onSeatClick && this.props.events.onSeatClick(e)

    e && e.seat && !e.seat.isSelected && e.seat.changeBorderColorToDefault()
  }

  clearTap = () => {
    this.lastTappedSeat = null
    this.setSeatLabelParameter({ visible: false })
  }

  seatTap = (e) => {
    const { seat } = e

    if (seat.objectType === 'UNCLICKABLE_TABLE') {
      return
    }

    if (
      (this.lastTappedSeat === seat &&
        _includes(
          [SEAT_STATUSES.AVAILABLE, SEAT_STATUSES.RESERVED_BY_ME],
          seat.status
        )) ||
      seat.isExternalLink
    ) {
      this.lastTappedSeat = null
      this.seatClick(e)
    } else {
      this.lastTappedSeat = seat
      this.mouseOverSeat(e, true)
    }
  }

  setSeatLabelParameter = (params) => {
    this.setState({
      seatLabelParams: { ...this.state.seatLabelParams, ...params }
    })
  }

  onSelectStart = () => {
    this.selectionInProgress = true
  }

  onSelectUp = (e) => {
    this.selectionInProgress = false
    this.props.events.onSelectUp && this.props.events.onSelectUp(e)
  }

  render() {
    const {
      state: {
        seatLabelParams,
        isBlockMap,
        showStatusesLabel,
        ticketTypeTireRelationsArray,
        tierPrices
      },
      props: {
        isTableMap,
        enableTicketTypeAssign,
        seatData: { svgData = {} }
      },
      controlsReset,
      controlsZoomIn,
      controlsZoomOut
    } = this
    const isSVGMap = !_isEmpty(svgData)

    return (
      <div className='seatMapContainer'>
        {!enableTicketTypeAssign && (
          <Fragment>
            {this.is_PPP ? (
              <ColorLabelsPPP
                showStatusesLabel={showStatusesLabel}
                colors={{
                  RESERVED: svgData.reservation_color,
                  BOOKED: svgData.booked_color
                }}
              />
            ) : (
              <ColorLabels
                showStatusesLabel={showStatusesLabel}
                isTableMap={isTableMap}
                isSVGMap={isSVGMap}
                svgData={svgData}
              />
            )}
          </Fragment>
        )}
        <ControlButtons
          isWheelChairAvailable={showStatusesLabel[SEAT_TYPES.WHEELCHAIR]}
          reset={controlsReset}
          zoomIn={controlsZoomIn}
          zoomOut={controlsZoomOut}
        />
        <div id='seatCanvasContainer' className='seatMapCanvasContainer'>
          {!isBlockMap && (
            <MouseLabel
              {...seatLabelParams}
              is_PPP={this.is_PPP}
              isTableMap={isTableMap}
              ticketTypeTireRelationsArray={ticketTypeTireRelationsArray}
              tierPrices={tierPrices}
            />
          )}
        </div>
      </div>
    )
  }
}

export { SeatMapView }
